const activeOwners = new Set<symbol>();

export const claimPlaidAnalytics = () => {
  const ownerId = Symbol('plaid-analytics-owner');
  activeOwners.add(ownerId);

  return () => {
    activeOwners.delete(ownerId);
  };
};

export const isPlaidAnalyticsClaimed = () => activeOwners.size > 0;
